import { createAction, createReducer } from 'redux-act'
import axios from 'axios'

// Default State
const defaultState = {
    katexCode: '',
    isLoadingCode: false,
    loadFailed: false
}

// Action Creators
export const actions = {
    startLoadingMath: createAction('Starts loading math'),
    mathLoadFailed: createAction('Failed math load'),
    mathLoadSuccessful: createAction('Successful math load', katexCode => ({
        katexCode
    }))
}

// Reducer
export default createReducer(
    {
        [actions.startLoadingMath]: state => ({
            ...state,
            isLoadingCode: true
        }),

        [actions.mathLoadSuccessful]: (state, { katexCode }) => ({
            katexCode,
            isLoadingCode: false,
            loadFailed: false
        }),

        [actions.mathLoadFailed]: state => ({
            katexCode: '',
            isLoadingCode: false,
            loadFailed: true
        })
    },
    defaultState
)

// Thunks
export const thunks = {
    loadMath: key => dispatch => {
        dispatch(actions.startLoadingMath())

        axios(`https://mathbox-d6e8f.firebaseio.com/math/${key}.json`)
            .then(resp => resp.data)
            .then(result => dispatch(actions.mathLoadSuccessful(result.math)))
            .catch(() => dispatch(actions.mathLoadFailed()))
    }
}



// WEBPACK FOOTER //
// ./src/ducks/viewShare.js